import { Fragment, useState, useEffect } from 'react';
import { connect } from 'react-redux';
import {
    getUserData,
    getCurrentVAccount,
    syncDrivePermissionsForEntity,
} from './helpers/Session';
import * as actionCreator from './actions';
import AppRoutes from './routes';
import AppOverlay from './components/Overlay/Overlay';
import LoginBackgroundURL from './assets/img/bg-login.jpeg';
import './App.scss';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { getPortalModules, getTagnameId } from './api/actions/Session';

const App = ({ session, profile, setSession, setProfile, setTagnameId }) => {
    const [loaded, setLoaded] = useState(false);

    useEffect(() => {
        const init = async () => {
            try {
                if (!loaded) {
                    if (session) {
                        const profile = await getUserData();
                        const tagsId = await getTagnameId();
                        const modules = await getPortalModules(
                            profile.entityId
                        );

                        let currentVirtualAccount = null;
                        if (!session.currentVirtualAccount) {
                            currentVirtualAccount = getCurrentVAccount(
                                profile,
                                session
                            );
                        } else {
                            currentVirtualAccount = profile._vAccounts.find(
                                (va) =>
                                    session.currentVirtualAccount ===
                                    va.entityId
                            );
                        }
                        profile._permissions =
                            currentVirtualAccount?.user?.permissions || {};

                        setTagnameId(tagsId);
                        setProfile(profile);
                        setSession({
                            ...session,
                            modules,
                            currentVirtualAccount:
                                currentVirtualAccount?.entityId,
                            tagsId: tagsId,
                        });
                        // set Permissions according to selected VA.
                        await syncDrivePermissionsForEntity();
                    }

                    setLoaded(true);
                }
            } catch (err) {
                console.log('Error on app init', err);
                setLoaded(true);
            }
        };
        init();
    }, []);

    return (
        <Fragment>
            {loaded ? (
                <AppRoutes session={session} profile={profile} />
            ) : (
                <>
                    <div
                        className="app-background-img"
                        style={{
                            backgroundImage: `url(${LoginBackgroundURL})`,
                        }}
                    />
                    <AppOverlay show />
                </>
            )}
            <ToastContainer />
        </Fragment>
    );
};

const mapStateToProps = (appState) => ({
    session: appState.session,
    profile: appState.userProfile,
});

const mapDispatchToProps = (dispatch) => ({
    setSession: (session) =>
        dispatch(actionCreator.Session.setSession(session)),
    setProfile: (profile) =>
        dispatch(actionCreator.Profile.setProfile(profile)),
    setTagnameId: (id) => dispatch(actionCreator.Session.setTagnameId(id)),
});

export default connect(mapStateToProps, mapDispatchToProps)(App);
